var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l(([1, 2, 3, 4, 5]),function(star){return _c('Stars',{key:star,attrs:{"active":_vm.initialStar >= star,"size":_vm.size},on:{"setActiveStar":function($event){return _vm.setActiveStar(star)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }